'use strict';

module.exports = 512;
